import { BarChart3Icon } from 'lucide-react'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { UpgradeDialog } from '@/components/upgrade-dialog'

// Blurred preview of a Pro screen behind an unlock prompt.
export function ProGate({ preview }: { preview: React.ReactNode }) {
  const { t } = useTranslation()
  const [upgradeOpen, setUpgradeOpen] = useState(false)

  return (
    <>
      <div className="relative flex-1 overflow-hidden">
        <div
          aria-hidden
          inert
          className="pointer-events-none absolute inset-x-0 top-(--app-hdr-h) select-none px-4 pt-4 opacity-50 blur-[6px]"
        >
          <div className="mx-auto max-w-(--page-col)">{preview}</div>
        </div>
        <div className="relative flex h-full flex-col items-center justify-center gap-8 bg-background/40 px-4 pb-16">
          <div className="flex flex-col items-center gap-3">
            <div className="mb-1 flex h-20 w-20 items-center justify-center rounded-3xl bg-primary/10">
              <BarChart3Icon className="h-9 w-9 text-primary-text" />
            </div>
            <h2 className="text-center text-2xl font-black text-foreground">
              {t('stats.proTitle')}
            </h2>
            <p className="max-w-xs text-center text-sm leading-relaxed text-foreground/60">
              {t('stats.proDesc')}
            </p>
          </div>

          <button
            type="button"
            onClick={() => setUpgradeOpen(true)}
            className="cursor-pointer w-full max-w-xs rounded-full bg-primary px-8 py-3.5 text-center text-base font-bold text-white dark:text-[#0a0a0a] transition-all hover:scale-[1.01] hover:bg-primary/90 active:scale-[0.99]"
          >
            {t('stats.proUnlock')}
          </button>
        </div>
      </div>

      <UpgradeDialog open={upgradeOpen} onOpenChange={setUpgradeOpen} reason="stats" />
    </>
  )
}
